"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const HelperUtils_1 = require("src/utils/HelperUtils");
const FormattedNumber = ({ number, minDecimalLength = 0, cursorClass = 'cursor-default', customClass = '', dataCy, withTruncate = false, withTooltip, useAbbrev = true }) => {
    var _a, _b;
    let integer = number;
    const unAbbrevNumber = number === null || number === void 0 ? void 0 : number.toLocaleString(navigator.language, {
        maximumFractionDigits: 20
    });
    if (number % 1 != 0) {
        // check if decimal
        integer = Math.trunc(number);
    }
    const additionalMinus = integer == 0 && number < 0 ? '-' : '';
    const decimals = integer === number ? '0' : (_b = (_a = number === null || number === void 0 ? void 0 : number.toString()) === null || _a === void 0 ? void 0 : _a.split('.')) === null || _b === void 0 ? void 0 : _b[1];
    let showTooltip = (decimals === null || decimals === void 0 ? void 0 : decimals.length) > 2;
    let displayNumber;
    if (Math.abs(integer) > 1000 && useAbbrev) {
        showTooltip = true;
        displayNumber = (0, HelperUtils_1.abbrevNumber)(integer, 2, false);
    }
    else {
        displayNumber = parseFloat(additionalMinus + integer + '.' + (decimals === null || decimals === void 0 ? void 0 : decimals.substring(0, 2))).toLocaleString(navigator.language, {
            minimumFractionDigits: minDecimalLength,
            maximumFractionDigits: 2
        });
        if (withTruncate && showTooltip) {
            displayNumber = displayNumber + '..';
        }
    }
    return (react_1.default.createElement(TooltipContainer_1.default, { show: withTooltip !== null && withTooltip !== void 0 ? withTooltip : showTooltip, text: unAbbrevNumber, classContainer: "inline-flex" },
        react_1.default.createElement("span", { className: (0, classnames_template_literals_1.default)(`${cursorClass} ${customClass}`), "data-cy": dataCy }, displayNumber)));
};
exports.default = FormattedNumber;
